import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });

// Auth contract: HttpOnly access cookie (12h) + refresh cookie (7d). On a 401 we transparently refresh the
// access cookie once and retry; if the refresh fails the session is over and the app returns to /login.
let refreshing = null;
const NO_REFRESH = /\/auth\/(login|refresh|logout|forgot-password|reset-password)/;
export const SESSION_EXPIRED_EVENT = "nm:session-expired";

http.interceptors.response.use(
  (r) => r,
  async (error) => {
    const { config, response } = error;
    const url = config?.url || "";
    if (response?.status === 401 && config && !config.__retried && !NO_REFRESH.test(url)) {
      config.__retried = true;
      try {
        refreshing = refreshing || axios.post(`${API}/auth/refresh`, {}, { withCredentials: true }).finally(() => { refreshing = null; });
        await refreshing;
        return http(config);
      } catch (e) {
        if (!/\/auth\/me/.test(url)) window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
      }
    }
    return Promise.reject(error);
  }
);

export function apiErr(e, fallback = "Si è verificato un errore.") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || fallback;
}

export const fileUrl = (attId) => `${API}/files/${attId}`;
